import { ChangeEvent } from 'react';
import { Checkbox as ChakraCheckbox } from '@chakra-ui/react';
import { trioUITheme } from '@/styles/theme';
import * as Styles from './Checkbox.styles';

export type CustomCheckboxProps = React.InputHTMLAttributes<HTMLInputElement> & {
  name: string;
  value?: string;
  checked?: boolean;
  label?: string;
  disabled?: boolean;
  errorMessage?: string;
  onChangeHandler?: (event: ChangeEvent<HTMLInputElement>) => void;
};

const Checkbox = ({
  label,
  name,
  value,
  checked,
  disabled,
  errorMessage,
  onChangeHandler,
  ...props
}: CustomCheckboxProps): JSX.Element => {
  return (
    <Styles.InputBox data-testid="checkbox" {...props}>
      <Styles.InputArea isDisabled={disabled} hasError={!!errorMessage}>
        <ChakraCheckbox
          disabled={disabled}
          size="sm"
          colorScheme="whiteAlpha"
          iconColor={trioUITheme.colors['neutral-90']}
          onChange={onChangeHandler}
          isChecked={checked}
          value={value}
          name={name}
        >
          {label}
        </ChakraCheckbox>
      </Styles.InputArea>

      {errorMessage && <Styles.CustomWarningMessage errorMessage={errorMessage} />}
    </Styles.InputBox>
  );
};

export default Checkbox;
